import { types, addDisposer, getParent } from 'mobx-state-tree';
import { Router } from 'director/build/director';
import { assign } from 'lodash';
import { reaction } from 'mobx';
import { Routes } from './Routes';

export const Role = types.model('Role', {
  name: types.identifier(types.string),
  routes: types.map(Routes),
  currentRoute: types.reference(Routes),
  navigating: types.optional(types.boolean, false),

  get currentUrl(): string {
    return this.currentRoute.url;
  },

  get viewStore() {
    const viewStore = getParent(getParent(this));
    if (viewStore === null || viewStore === undefined) {
      throw new Error('view store not found in role');
    }
    return viewStore;
  }
}, {
    router: null,
  }, {
    changeView(name: string, params?: string[], navigating?: boolean) {
      if (this.viewStore.userStore.onChangeView) {
        this.viewStore.userStore.onChangeView(this.viewStore, name, params, navigating);
      } else {
        this.innerChangeView(name, params, navigating);
      }
    },

    innerChangeView(name: string, params?: string[], navigating?: boolean) {
      const selectedRoute = this.routes.get(name);
      if (selectedRoute) {
        if (selectedRoute.hasParams) {
          if (!params) {
            throw new Error(`no params provided for route [${name}]:
             with params ${JSON.stringify(selectedRoute.params)}`);
          }
          if (params.length !== selectedRoute.params.length) {
            throw new Error(`mismatch in params for route [${name}]:
             found: ${params.length} parameters 
             required: ${selectedRoute.params.length} parameters
             params needed: ${selectedRoute.params}
             `);
          }
          selectedRoute.setParamValues(params);
        } else if (params) {
          throw new Error(`params provided for route [${name}]: has no params`);
        }
        this.navigating = navigating === undefined ? false : true;
        this.currentRoute = selectedRoute;
      } else {
        throw new Error(`Invalid view [${name}]: available views: ${JSON.stringify(this.routes.keys())}`);
      }
    },

    afterCreate() {
      // tslint:disable-next-line:no-console
      console.log(`hooking up routes`);
      const self = this;
      const routes = this.routes.values().map(route => (
        route.hasParams ?
          {
            [route.path]: function () {
              const params: string[] = [];
              for (let i = 0; i < arguments.length; i++) {
                params.push(arguments[i]);
              }
              self.changeView(route.name, params, true);
            }
          } :
          { [route.path]: () => this.changeView(route.name, undefined, true) }
      ));
      const router = new Router(assign({}, ...routes)).configure({
        notfound: () => this.changeView('landing'),
      });
      router.init('/');
      this.router = router;
      addDisposer(this,
        reaction(() => this.currentUrl, () => {
          if (this.navigating) {
            return;
          }
          const path = this.currentUrl;

          if (path !== router.getRoute()) {
            // tslint:disable-next-line:no-console
            console.log(`view store changed to ${path} from ${router.getRoute()}`);
            router.setRoute(path);
          }
        }));
    },
  });


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/common/stores/Roles.ts